// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3scAY","icon":"styles_icon__3kVSj"};